export default __webpack_public_path__ + "fonts/resource_bg.b9cd108714e1ae79732cdb3f4ca47495.jpg";